import React from "react";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
    return (
        <div className="content">
            <h2>
                <Link to="/">Home</Link> / Terms of Use
            </h2>
            <br />

            <p align="center">
                <b>SHAREMY TERMS OF USE</b>
            </p>
            <p>
                <b>Effective Date: July 21, 2026</b>
            </p>

            <ul>
                <li><a href="#section1">1. Introduction</a></li>
                <li><a href="#section2">2. Related Policies</a></li>
                <li><a href="#section3">3. Eligibility</a></li>
                <li><a href="#section4">4. Nature of the Platform (Technology Platform Only)</a></li>
                <li><a href="#section5">5. Ambassadors, Promoters, Organizers, and Independent Contractors</a></li>
                <li><a href="#section6">6. User Responsibilities</a></li>
                <li><a href="#section7">7. User Content and Platform Content</a></li>
                <li><a href="#section8">8. Activities, Invitations, and User Interactions</a></li>
                <li><a href="#section9">9. Messaging and Communications</a></li>
                <li><a href="#section10">10. Payments, Premium Services, and Subscriptions</a></li>
                <li><a href="#section11">11. Intellectual Property</a></li>
                <li><a href="#section12">12. Third-Party Services and Links</a></li>
                <li><a href="#section13">13. Disclaimers</a></li>
                <li><a href="#section14">14. Assumption of Risk</a></li>
                <li><a href="#section15">15. Release of Claims</a></li>
                <li><a href="#section16">16. Limitation of Liability</a></li>
                <li><a href="#section17">17. Indemnification</a></li>
                <li><a href="#section18">18. Suspension and Termination</a></li>
                <li><a href="#section19">19. Dispute Resolution and Arbitration</a></li>
                <li><a href="#section20">20. Governing Law</a></li>
                <li><a href="#section21">21. Changes to These Terms</a></li>
                <li><a href="#section22">22. Miscellaneous</a></li>
                <li><a href="#section23">23. Contact Information</a></li>
            </ul>

            <p id="section1"><b>1. Introduction</b></p>
            <p>Welcome to ShareMy.</p>
            <p>
                These Terms of Use ("Terms") are a legally binding agreement between you and ShareMy
                Inc. ("ShareMy," "we," "our," or "us") governing your access to and use of the ShareMy
                mobile applications, website, and all related products, features, content, and services
                (collectively, the "Services").
            </p>
            <p>
                ShareMy provides a technology platform designed to help users discover activities,
                connect with other users, organize activities, communicate, and participate in
                user-organized experiences. ShareMy provides the technology that enables these
                interactions but does not organize, operate, supervise, or control the activities
                created or conducted by users.
            </p>
            <p>
                By creating an account, accessing, or using the Services, you acknowledge that you have
                read, understood, and agree to be bound by these Terms and all policies incorporated by
                reference. If you do not agree to these Terms, you may not access or use the Services.
            </p>
            <p>
                These Terms apply to all visitors, registered users, organizers, ambassadors,
                promoters, and any other individuals who access or use the Services.
            </p>
            <p>
                Your use of the Services is also subject to applicable federal, state, and local laws.
                You are solely responsible for ensuring that your use of the Services complies with all
                laws applicable to you.
            </p>

            <p id="section2"><b>2. Related Policies</b></p>
            <p>
                The following policies are incorporated into these Terms by reference and form part of
                the agreement between you and ShareMy:
            </p>
            <ul>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                <li><Link to="/community-guide">Community Guidelines</Link></li>
                <li><Link to="/safety-guide">Safety Guidelines</Link></li>
            </ul>
            <p>Each of these documents governs different aspects of your use of the Services.</p>
            <p>
                The Privacy Policy explains how ShareMy collects, uses, shares, stores, and otherwise
                processes your personal information.
            </p>
            <p>
                The Cookie Policy explains how cookies and similar technologies are used on the ShareMy
                website and related Services.
            </p>
            <p>
                The Community Guidelines establish standards for appropriate conduct and content while
                using the Services.
            </p>
            <p>
                The Safety Guidelines provide recommendations intended to help users make informed
                decisions when participating in activities or interacting with other users. The Safety
                Guidelines are provided for informational purposes only and do not create any duty on
                the part of ShareMy to monitor, supervise, investigate, or protect users.
            </p>
            <p>
                If there is a conflict between these Terms and any other ShareMy policy, these Terms
                control unless the conflicting policy expressly states otherwise.
            </p>
            <p>
                ShareMy may update these policies from time to time. Continued use of the Services after
                updated policies become effective constitutes your acceptance of those updates to the
                extent permitted by applicable law.
            </p>

            <p id="section3"><b>3. Eligibility</b></p>
            <p>
                To create a ShareMy account or use the Services, you must satisfy all of the following
                requirements:
            </p>
            <ul>
                <li>You are at least eighteen (18) years of age.</li>
                <li>You reside in the United States or are otherwise authorized by ShareMy to use the Services.</li>
                <li>You have the legal capacity and authority to enter into a binding agreement.</li>
                <li>You are not prohibited by applicable law from using the Services.</li>
                <li>Your ShareMy account has not previously been suspended or terminated by ShareMy, unless we have expressly authorized your return to the Services.</li>
            </ul>
            <p>
                By creating an account or using the Services, you represent and warrant that you meet
                each of these eligibility requirements and will continue to do so while using the
                Services.
            </p>

            <p><b>A. Accurate Registration Information</b></p>
            <p>
                When creating an account, you agree to provide information that is accurate, current,
                and complete.
            </p>
            <p>
                You agree to keep your account information reasonably current and to promptly update
                your account if your information changes.
            </p>
            <p>You may not:</p>
            <ul>
                <li>Create an account using false or misleading information.</li>
                <li>Impersonate another individual or organization.</li>
                <li>Create an account on behalf of another person without their authorization.</li>
                <li>Misrepresent your identity, qualifications, certifications, affiliations, or experience.</li>
            </ul>
            <p>
                ShareMy reserves the right to suspend or terminate accounts that contain materially
                false, misleading, or fraudulent information.
            </p>

            <p><b>B. One Account Per Individual</b></p>
            <p>
                Unless expressly authorized by ShareMy, each individual may maintain only one personal
                ShareMy account.
            </p>
            <p>You may not create additional accounts to:</p>
            <ul>
                <li>Circumvent suspensions or restrictions.</li>
                <li>Evade enforcement of these Terms.</li>
                <li>Misrepresent your identity.</li>
                <li>Manipulate recommendations, ratings, participation records, or other features of the Services.</li>
            </ul>

            <p><b>C. Adults-Only Platform</b></p>
            <p>ShareMy is intended solely for adults.</p>
            <p>Individuals under the age of eighteen (18) may not create an account, access, or use the Services.</p>
            <p>
                If ShareMy reasonably believes that an account is being used by or on behalf of an
                individual under the age of 18, we may suspend or terminate the account and take any
                other action permitted by these Terms or applicable law.
            </p>

            <p><b>D. Right to Refuse or Terminate Access</b></p>
            <p>
                ShareMy reserves the right, in its sole discretion and to the fullest extent permitted
                by applicable law, to refuse registration, suspend, restrict, or terminate access to
                the Services at any time, with or without notice, for any lawful reason, including a
                violation of these Terms or our related policies.
            </p>
            <p>
                Nothing in these Terms obligates ShareMy to approve, maintain, or continue any user's
                access to the Services.
            </p>

            <p id="section4"><b>4. Nature of the Platform (Technology Platform Only)</b></p>
            <p>
                ShareMy provides a technology platform that enables users to discover activities,
                connect with other users, communicate, organize activities, and participate in
                user-organized experiences through the Services.
            </p>
            <p>
                ShareMy provides the technology that facilitates these interactions but is not a
                provider, organizer, operator, sponsor, manager, host, or supervisor of the activities,
                events, services, or experiences offered, created, promoted, or attended by users,
                except where ShareMy expressly identifies an activity as an official ShareMy event in
                writing.
            </p>
            <p>
                All activities, events, meetings, communications, and interactions arranged through the
                Services are initiated, organized, and conducted primarily by users or other
                independent third parties.
            </p>
            <p>
                ShareMy is not a party to agreements, arrangements, or understandings between users and
                assumes no responsibility for the performance, cancellation, quality, legality, safety,
                or outcome of any activity or interaction.
            </p>

            <p><b>A. What ShareMy Does</b></p>
            <p>ShareMy provides technology that allows users to:</p>
            <ul>
                <li>Create and manage profiles.</li>
                <li>Discover activities and events.</li>
                <li>Connect with other users.</li>
                <li>Send and receive invitations.</li>
                <li>Exchange messages.</li>
                <li>Organize activities.</li>
                <li>Join activities organized by others.</li>
                <li>Receive automated recommendations.</li>
                <li>Use other features offered through the Services.</li>
            </ul>
            <p>
                The Services are intended solely to facilitate connections and communications between
                users.
            </p>

            <p><b>B. What ShareMy Does Not Do</b></p>
            <p>Unless ShareMy expressly agrees otherwise in writing, ShareMy does not:</p>
            <ul>
                <li>Organize, host, supervise, manage, or control user-organized activities.</li>
                <li>Act as an agent, partner, joint venturer, or representative of users.</li>
                <li>Provide transportation, lodging, equipment, guides, instructors, security, medical services, or insurance.</li>
                <li>Verify the identity, background, qualifications, certifications, licenses, training, experience, or intentions of users.</li>
                <li>Conduct criminal background checks, reference checks, or other investigations of users.</li>
                <li>Inspect or approve activity locations, venues, routes, equipment, or facilities.</li>
                <li>Guarantee the legality, quality, suitability, or safety of any activity or interaction.</li>
                <li>Monitor every activity, message, communication, or interaction occurring through or outside the Services.</li>
                <li>Guarantee that users will behave lawfully, honestly, safely, respectfully, or in accordance with these Terms.</li>
            </ul>
            <p>
                ShareMy may review content, investigate reports, remove content, suspend accounts, or
                enforce these Terms and related policies at its sole discretion. Any such action is
                voluntary and does not create a continuing obligation or legal duty to take similar
                action in the future.
            </p>

            <p><b>C. Independent Users</b></p>
            <p>
                All users act solely on their own behalf and are independently responsible for their
                own conduct and decisions.
            </p>
            <p>Users are solely responsible for evaluating:</p>
            <ul>
                <li>The people with whom they interact.</li>
                <li>The activities in which they participate.</li>
                <li>The locations they visit.</li>
                <li>The risks they choose to accept.</li>
                <li>Their own decisions before, during, and after any interaction arranged through the Services.</li>
            </ul>

            <p><b>D. No Duty to Monitor or Protect</b></p>
            <p>
                To the fullest extent permitted by applicable law, ShareMy does not assume and expressly
                disclaims any duty to:
            </p>
            <ul>
                <li>Monitor users.</li>
                <li>Screen users.</li>
                <li>Verify information provided by users.</li>
                <li>Conduct background investigations.</li>
                <li>Supervise activities.</li>
                <li>Inspect locations.</li>
                <li>Resolve disputes between users.</li>
                <li>Warn users of potential risks.</li>
                <li>Prevent misconduct.</li>
                <li>Protect users from the acts or omissions of other users or third parties.</li>
                <li>Guarantee the safety, legality, quality, or success of any activity or interaction.</li>
            </ul>
            <p>
                Although ShareMy may voluntarily investigate reports, remove content, suspend accounts,
                or otherwise enforce these Terms, ShareMy has no obligation to take any particular
                action and assumes no legal duty by choosing to do so.
            </p>

            <p><b>E. No Special Relationship</b></p>
            <p>
                Nothing in these Terms, the Privacy Policy, the Community Guidelines, the Safety
                Guidelines, or any action taken by ShareMy creates:
            </p>
            <ul>
                <li>A fiduciary relationship.</li>
                <li>A special relationship.</li>
                <li>An agency relationship.</li>
                <li>A partnership.</li>
                <li>A joint venture.</li>
                <li>An employment relationship.</li>
                <li>A duty to rescue.</li>
                <li>A duty to investigate.</li>
                <li>A duty to monitor.</li>
                <li>A duty to warn.</li>
                <li>A duty to protect.</li>
                <li>Any legal duty beyond those expressly required by applicable law.</li>
            </ul>
            <p>
                You acknowledge that your participation in activities and your interactions with other
                users are undertaken voluntarily and at your own discretion.
            </p>

            <p><b>F. Recommendations Are Not Endorsements</b></p>
            <p>
                ShareMy may use automated systems, algorithms, artificial intelligence, or other
                technologies to recommend activities, users, groups, locations, or other content based
                on information you provide and your interactions with the Services.
            </p>
            <p>
                These recommendations are provided solely as informational suggestions to help you
                discover opportunities that may interest you.
            </p>
            <p>
                Recommendations do not constitute endorsements, certifications, guarantees, or
                representations by ShareMy regarding:
            </p>
            <ul>
                <li>Safety.</li>
                <li>Compatibility.</li>
                <li>Qualifications.</li>
                <li>Legality.</li>
                <li>Reliability.</li>
                <li>Availability.</li>
                <li>Suitability.</li>
                <li>Quality.</li>
                <li>Accuracy.</li>
                <li>Any expected outcome.</li>
            </ul>
            <p>
                You are solely responsible for evaluating all recommendations before deciding whether to
                interact with another user or participate in any activity.
            </p>

            <p id="section5"><b>5. Ambassadors, Promoters, Organizers, and Independent Contractors</b></p>
            <p>
                To help promote the Services and build the ShareMy community, ShareMy may engage
                independent contractors, including ambassadors, promoters, organizers, influencers, or
                similar representatives, under separate written agreements.
            </p>
            <p>Unless ShareMy expressly states otherwise in writing:</p>
            <ul>
                <li>Independent contractors are not employees of ShareMy.</li>
                <li>Independent contractors are not agents of ShareMy.</li>
                <li>Independent contractors have no authority to bind ShareMy to any contract, promise, warranty, representation, or obligation.</li>
                <li>Independent contractors may promote the Services only within the scope of their written agreement with ShareMy.</li>
            </ul>
            <p>
                An ambassador, promoter, organizer, or other independent contractor who creates, hosts,
                leads, promotes, or participates in an activity does so in that individual's own
                capacity as the activity organizer or participant, and not as ShareMy's representative,
                unless ShareMy has expressly designated the activity as an official ShareMy event in
                writing.
            </p>
            <p>
                Independent contractors are responsible for complying with their agreements with
                ShareMy, these Terms, and all applicable laws. ShareMy is not responsible for the
                independent decisions, conduct, statements, omissions, or actions of independent
                contractors that are outside the scope of their written agreement with ShareMy.
            </p>
            <p>
                Nothing in these Terms or any participation in the Services creates an employment
                relationship, agency, partnership, joint venture, franchise, or other representative
                relationship between ShareMy and any user unless expressly established in a separate
                written agreement signed by ShareMy.
            </p>

            <p id="section6"><b>6. User Responsibilities</b></p>
            <p>
                By accessing or using the Services, you agree to act responsibly, exercise good
                judgment, and comply with these Terms, our related policies, and all applicable laws.
            </p>
            <p>
                You are solely responsible for your conduct, decisions, communications, and
                participation in any activity or interaction arranged through the Services.
            </p>

            <p><b>A. Compliance with Laws</b></p>
            <p>
                You agree to comply with all applicable federal, state, and local laws, regulations,
                ordinances, and governmental requirements while using the Services or participating in
                any activity.
            </p>
            <p>
                You are solely responsible for obtaining any licenses, permits, permissions, or
                approvals required for activities you organize or participate in.
            </p>
            <p>ShareMy is not responsible for determining whether any activity complies with applicable laws.</p>

            <p><b>B. Your Decisions</b></p>
            <p>You are solely responsible for deciding:</p>
            <ul>
                <li>Whether to create or join an activity.</li>
                <li>Whether to communicate with another user.</li>
                <li>Whether to disclose personal information.</li>
                <li>Whether to meet another user.</li>
                <li>Whether to continue participating in any activity.</li>
                <li>Whether an activity is appropriate for your abilities, experience, health, and circumstances.</li>
            </ul>
            <p>
                You acknowledge that every activity involves different levels of risk, and you are
                solely responsible for evaluating those risks before participating.
            </p>

            <p><b>C. Your Safety</b></p>
            <p>
                You are solely responsible for your own safety and for taking reasonable precautions
                before, during, and after any interaction with another user.
            </p>
            <p>This includes, when appropriate:</p>
            <ul>
                <li>Meeting in public places.</li>
                <li>Informing others of your plans.</li>
                <li>Using appropriate equipment.</li>
                <li>Following applicable laws and regulations.</li>
                <li>Exercising sound judgment.</li>
                <li>Leaving any activity or interaction that you believe is unsafe.</li>
            </ul>
            <p>
                ShareMy's Safety Guidelines are provided for informational purposes only and do not
                replace your own judgment or create any duty on the part of ShareMy.
            </p>

            <p><b>D. Information You Share</b></p>
            <p>
                You are solely responsible for the information you choose to share through the Services
                or directly with other users.
            </p>
            <p>
                Once you voluntarily disclose information to another user, ShareMy cannot control how
                that information is used, stored, shared, or disclosed by that recipient.
            </p>
            <p>You should carefully consider what personal information you choose to make available to others.</p>

            <p><b>E. Account Security</b></p>
            <p>You are responsible for maintaining the confidentiality of your account credentials.</p>
            <p>You agree to:</p>
            <ul>
                <li>Keep your login credentials secure.</li>
                <li>Use a strong password where applicable.</li>
                <li>Notify ShareMy promptly if you believe your account has been compromised.</li>
                <li>Log out of shared devices.</li>
            </ul>
            <p>
                You are responsible for all activities occurring under your account unless prohibited by
                applicable law.
            </p>

            <p><b>F. Equipment and Internet Access</b></p>
            <p>You are responsible for obtaining and maintaining:</p>
            <ul>
                <li>A compatible device.</li>
                <li>Internet access.</li>
                <li>Cellular or data service.</li>
                <li>GPS functionality, when desired.</li>
                <li>Any equipment necessary to use the Services.</li>
            </ul>
            <p>
                Any fees charged by your mobile carrier, internet provider, or other third parties are
                your responsibility.
            </p>

            <p><b>G. Respect for Other Users</b></p>
            <p>You agree to interact respectfully and lawfully with other users.</p>
            <p>You may not use the Services to:</p>
            <ul>
                <li>Harass, threaten, intimidate, or stalk others.</li>
                <li>Discriminate against others.</li>
                <li>Defraud or deceive others.</li>
                <li>Impersonate another person.</li>
                <li>Violate another person's privacy or legal rights.</li>
                <li>Engage in unlawful or dangerous conduct.</li>
            </ul>
            <p>
                Additional standards of conduct are described in the Community Guidelines, which are
                incorporated into these Terms.
            </p>

            <p><b>H. Reporting Concerns</b></p>
            <p>
                If you become aware of conduct that you reasonably believe violates these Terms, the
                Community Guidelines, or applicable law, you are encouraged to report it through the
                reporting tools provided in the Services or by contacting ShareMy.
            </p>
            <p>
                ShareMy may review reports in its sole discretion but is not obligated to investigate,
                resolve, or take action regarding every report.
            </p>

            <p id="section7"><b>7. User Content and Platform Content</b></p>
            <p>
                The Services allow users to create, upload, post, submit, transmit, organize, publish,
                store, and share content, including profiles, photographs, videos, comments, messages,
                reviews, activity descriptions, invitations, location information, and other materials
                (collectively, "User Content").
            </p>
            <p>
                You remain responsible for all User Content that you create, submit, or share through
                the Services.
            </p>

            <p><b>A. Ownership of User Content</b></p>
            <p>
                Except for the limited license granted below, you retain ownership of any intellectual
                property rights you have in your User Content.
            </p>
            <p>Nothing in these Terms transfers ownership of your User Content to ShareMy.</p>
            <p>
                You are solely responsible for ensuring that you have all necessary rights, permissions,
                and authority to upload or share your User Content.
            </p>

            <p><b>B. License Granted to ShareMy</b></p>
            <p>
                By submitting, posting, uploading, transmitting, or otherwise making User Content
                available through the Services, you grant ShareMy a worldwide, non-exclusive,
                royalty-free, transferable, sublicensable license to:
            </p>
            <ul>
                <li>Host</li>
                <li>Store</li>
                <li>Copy</li>
                <li>Reproduce</li>
                <li>Display</li>
                <li>Publish</li>
                <li>Perform</li>
                <li>Distribute</li>
                <li>Modify</li>
                <li>Adapt</li>
                <li>Format</li>
                <li>Translate</li>
                <li>Create derivative works</li>
                <li>Index</li>
                <li>Analyze</li>
                <li>Process</li>
                <li>Transmit</li>
                <li>Use</li>
            </ul>
            <p>your User Content solely as reasonably necessary to:</p>
            <ul>
                <li>Operate the Services.</li>
                <li>Provide requested features.</li>
                <li>Display your content to users you authorize to view it.</li>
                <li>Process invitations and communications.</li>
                <li>Improve and maintain the Services.</li>
                <li>Develop new features.</li>
                <li>Moderate content.</li>
                <li>Detect fraud, abuse, spam, or policy violations.</li>
                <li>Train, improve, or evaluate automated systems used to operate the Services, provided such use is consistent with the Privacy Policy and applicable law.</li>
                <li>Comply with legal obligations.</li>
                <li>Enforce these Terms.</li>
            </ul>
            <p>
                This license continues only for as long as reasonably necessary to operate the Services
                and fulfill the purposes described above, subject to applicable law and our data
                retention practices described in the Privacy Policy.
            </p>

            <p><b>C. Your Representations and Warranties</b></p>
            <p>You represent and warrant that:</p>
            <ul>
                <li>You own or have all necessary rights to your User Content.</li>
                <li>Your User Content does not infringe the intellectual property, privacy, publicity, or other legal rights of any person.</li>
                <li>Your User Content is accurate to the best of your knowledge.</li>
                <li>Your User Content complies with these Terms, the Community Guidelines, and applicable law.</li>
                <li>You have obtained any required permissions from individuals appearing in photographs, videos, or other media that you upload, where required by law.</li>
            </ul>

            <p><b>D. Responsibility for User Content</b></p>
            <p>
                You are solely responsible for your User Content and the consequences of posting or
                sharing it.
            </p>
            <p>
                ShareMy does not endorse, verify, guarantee, or assume responsibility for User Content
                created by users.
            </p>
            <p>
                User Content may be inaccurate, incomplete, misleading, offensive, unlawful, or
                otherwise objectionable.
            </p>
            <p>Your reliance upon User Content is entirely at your own risk.</p>

            <p><b>E. Content Moderation</b></p>
            <p>ShareMy may, but has no obligation to:</p>
            <ul>
                <li>Review User Content.</li>
                <li>Monitor User Content.</li>
                <li>Remove User Content.</li>
                <li>Edit User Content.</li>
                <li>Restrict visibility of User Content.</li>
                <li>Disable access to User Content.</li>
                <li>Suspend or terminate accounts associated with User Content.</li>
            </ul>
            <p>
                ShareMy may take these actions in its sole discretion, with or without notice, when it
                reasonably believes doing so is appropriate or necessary.
            </p>
            <p>
                ShareMy's decision to review or remove some content does not create a duty to review all
                content or to continue reviewing content in the future.
            </p>

            <p><b>F. Feedback and Suggestions</b></p>
            <p>
                If you voluntarily provide ShareMy with ideas, suggestions, comments, recommendations,
                feature requests, or other feedback regarding the Services ("Feedback"), you grant
                ShareMy a perpetual, irrevocable, worldwide, royalty-free, transferable, sublicensable
                license to use, modify, reproduce, distribute, display, publish, and otherwise exploit
                that Feedback for any lawful purpose without compensation, attribution, or further
                permission.
            </p>

            <p><b>G. Platform Content</b></p>
            <p>
                Except for User Content, all content made available through the Services&mdash;including
                the ShareMy name, logos, trademarks, service marks, software, designs, graphics, text,
                photographs, videos, databases, compilations, and other materials ("Platform
                Content")&mdash;is owned by or licensed to ShareMy and is protected by applicable
                intellectual property and other laws.
            </p>
            <p>Except as expressly permitted by these Terms or applicable law, you may not:</p>
            <ul>
                <li>Copy.</li>
                <li>Modify.</li>
                <li>Distribute.</li>
                <li>Sell.</li>
                <li>License.</li>
                <li>Reverse engineer.</li>
                <li>Create derivative works from.</li>
                <li>Publicly display.</li>
                <li>Publicly perform.</li>
                <li>Exploit.</li>
            </ul>
            <p>any Platform Content without ShareMy's prior written permission.</p>

            <p><b>H. Copyright Complaints</b></p>
            <p>ShareMy respects the intellectual property rights of others.</p>
            <p>
                If you believe that material available through the Services infringes your copyright or
                other intellectual property rights, you may submit a written notice containing
                sufficient information for ShareMy to evaluate the claim.
            </p>
            <p>
                ShareMy may remove or disable access to allegedly infringing material and may terminate
                repeat infringers where appropriate.
            </p>

            <p><b>I. No Obligation to Retain Content</b></p>
            <p>ShareMy is not obligated to store, maintain, or preserve User Content indefinitely.</p>
            <p>
                Subject to applicable law and the Privacy Policy, ShareMy may delete, archive, or remove
                User Content after account termination, inactivity, legal requests, operational needs,
                or for other lawful reasons.
            </p>
            <p>Users are solely responsible for maintaining their own copies of any content they wish to preserve.</p>

            <p id="section8"><b>8. Activities, Invitations, and User Interactions</b></p>
            <p>
                The Services allow users to create, discover, organize, join, promote, and participate
                in activities and to communicate with other users regarding those activities.
            </p>
            <p>
                All activities are organized and conducted by users or other independent third parties
                unless ShareMy expressly identifies an activity as an official ShareMy event.
            </p>

            <p><b>A. User-Organized Activities</b></p>
            <p>
                Users are solely responsible for any activity they create, organize, host, lead,
                promote, or attend.
            </p>
            <p>
                Organizers are responsible for providing accurate information about their activities,
                including descriptions, locations, dates, times, participation requirements, fees,
                equipment, and any applicable rules.
            </p>
            <p>
                Participants are solely responsible for determining whether an activity is appropriate
                for their abilities, experience, health, and personal circumstances.
            </p>

            <p><b>B. Invitations</b></p>
            <p>The Services may allow users to invite others to participate in activities.</p>
            <p>Invitations are informational only.</p>
            <p>An invitation does not:</p>
            <ul>
                <li>Create a contract.</li>
                <li>Guarantee participation.</li>
                <li>Guarantee attendance.</li>
                <li>Guarantee compatibility.</li>
                <li>Guarantee safety.</li>
                <li>Create any obligation between users.</li>
            </ul>
            <p>
                Users remain free to accept, decline, withdraw from, or cancel participation at any time
                unless they have separately agreed otherwise.
            </p>

            <p><b>C. User Interactions</b></p>
            <p>All communications and interactions between users occur solely at the users' own discretion and risk.</p>
            <p>ShareMy does not supervise, control, or direct user communications or real-world interactions.</p>
            <p>
                Users are solely responsible for exercising reasonable judgment before sharing personal
                information, meeting another user, participating in an activity, or entering into any
                agreement with another user.
            </p>

            <p><b>D. Activity Changes and Cancellations</b></p>
            <p>Activities may be changed, postponed, relocated, or cancelled by organizers at any time.</p>
            <p>ShareMy is not responsible for:</p>
            <ul>
                <li>Schedule changes.</li>
                <li>Cancellations.</li>
                <li>Weather.</li>
                <li>Venue closures.</li>
                <li>Organizer decisions.</li>
                <li>Participant decisions.</li>
                <li>Travel expenses.</li>
                <li>Equipment costs.</li>
                <li>Lodging costs.</li>
                <li>Lost opportunities.</li>
                <li>Any resulting damages or inconvenience.</li>
            </ul>

            <p><b>E. User Disputes</b></p>
            <p>Disputes arising between users are solely the responsibility of the users involved.</p>
            <p>
                Although ShareMy may, in its sole discretion, assist in resolving disputes or investigate
                reported conduct, ShareMy has no obligation to do so and assumes no liability arising
                from disputes between users.
            </p>

            <p><b>F. No Endorsement</b></p>
            <p>
                The appearance of an activity, organizer, participant, profile, review, recommendation,
                invitation, or other content on the Services does not constitute an endorsement,
                approval, certification, or recommendation by ShareMy.
            </p>

            <p id="section9"><b>9. Messaging and Communications</b></p>
            <p>
                The Services may include messaging, invitations, notifications, announcements, customer
                support, and other communication features.
            </p>
            <p>These features are provided solely as tools to facilitate communication.</p>

            <p><b>A. User Messages</b></p>
            <p>Users are solely responsible for the messages and communications they send through the Services.</p>
            <p>You agree not to use the Services to send messages that are:</p>
            <ul>
                <li>Unlawful.</li>
                <li>Fraudulent.</li>
                <li>Harassing.</li>
                <li>Threatening.</li>
                <li>Defamatory.</li>
                <li>Obscene.</li>
                <li>Misleading.</li>
                <li>Spam.</li>
                <li>Malicious.</li>
                <li>In violation of another person's rights.</li>
            </ul>

            <p><b>B. Monitoring Communications</b></p>
            <p>ShareMy does not routinely monitor private communications between users.</p>
            <p>However, ShareMy may review communications when reasonably necessary to:</p>
            <ul>
                <li>Investigate reported misconduct.</li>
                <li>Respond to legal requests.</li>
                <li>Protect the integrity of the Services.</li>
                <li>Detect fraud or abuse.</li>
                <li>Enforce these Terms.</li>
                <li>Comply with applicable law.</li>
            </ul>
            <p>Nothing in this section creates a duty for ShareMy to monitor communications.</p>

            <p><b>C. Service Communications</b></p>
            <p>By creating an account, you agree that ShareMy may send communications related to:</p>
            <ul>
                <li>Account security.</li>
                <li>Login verification.</li>
                <li>Password resets.</li>
                <li>Activity invitations.</li>
                <li>Messages from other users.</li>
                <li>Service announcements.</li>
                <li>Transaction confirmations.</li>
                <li>Subscription information.</li>
                <li>Policy updates.</li>
                <li>Customer support.</li>
                <li>Other operational matters.</li>
            </ul>
            <p>These communications are considered part of the Services.</p>

            <p><b>D. Promotional Communications</b></p>
            <p>
                Where permitted by applicable law, ShareMy may send promotional emails, newsletters, or
                marketing communications.
            </p>
            <p>
                You may opt out of promotional communications at any time by using the unsubscribe
                mechanism provided or by updating your account settings.
            </p>
            <p>
                Operational and transactional communications may continue even if you opt out of
                promotional communications.
            </p>

            <p><b>E. Third-Party Communication Services</b></p>
            <p>
                ShareMy may use third-party communication providers to deliver messages, notifications,
                verification codes, email communications, or other communications.
            </p>
            <p>Delivery of communications cannot be guaranteed.</p>
            <p>
                ShareMy is not responsible for delays, failures, filtering, interruptions, or errors
                caused by telecommunications providers, internet service providers, device
                manufacturers, email providers, mobile carriers, or other third parties.
            </p>

            <p id="section10"><b>10. Payments, Premium Services, and Subscriptions</b></p>
            <p>
                Certain features of the Services may require payment, including premium subscriptions,
                optional features, or other paid services.
            </p>
            <p>Purchases are optional unless expressly stated otherwise.</p>

            <p><b>A. Subscription Services</b></p>
            <p>
                ShareMy may offer recurring subscription plans, premium memberships, one-time purchases,
                or other paid features.
            </p>
            <p>
                Subscription pricing, billing intervals, available features, and renewal terms will be
                disclosed before purchase.
            </p>

            <p><b>B. Billing</b></p>
            <p>
                By purchasing a subscription or paid feature, you authorize the applicable payment
                provider to charge your selected payment method for all applicable fees, taxes, and
                recurring charges.
            </p>
            <p>Recurring subscriptions will automatically renew unless cancelled before the renewal date.</p>

            <p><b>C. Payment Processors</b></p>
            <p>
                Payments may be processed by third-party providers, including Apple, Google, Stripe,
                RevenueCat, or other authorized payment processors.
            </p>
            <p>ShareMy does not receive or store your complete payment card information.</p>
            <p>Your use of third-party payment providers is governed by their respective terms and privacy policies.</p>

            <p><b>D. Taxes</b></p>
            <p>
                You are responsible for any applicable taxes, duties, governmental fees, or similar
                charges associated with your purchases unless applicable law requires otherwise.
            </p>

            <p><b>E. Refunds</b></p>
            <p>Refund eligibility is determined by:</p>
            <ul>
                <li>Applicable law.</li>
                <li>The payment platform used.</li>
                <li>The terms of the applicable payment processor.</li>
            </ul>
            <p>
                Purchases made through the Apple App Store or Google Play are generally subject to those
                platforms' refund policies.
            </p>
            <p>
                Unless required by applicable law or expressly stated otherwise, payments are
                non-refundable.
            </p>

            <p><b>F. Price Changes</b></p>
            <p>ShareMy may change pricing, subscription plans, or available features at any time.</p>
            <p>
                Any price changes affecting recurring subscriptions will apply prospectively and, where
                required by applicable law, only after reasonable notice has been provided.
            </p>

            <p><b>G. Suspension for Non-Payment</b></p>
            <p>
                ShareMy may suspend or terminate access to paid features if payment cannot be
                successfully processed or if recurring charges remain unpaid.
            </p>

            <p><b>H. No Guarantee of Availability</b></p>
            <p>
                Payment for a subscription or premium feature grants access only to the features
                included with that subscription during the applicable subscription period.
            </p>
            <p>
                ShareMy does not guarantee uninterrupted availability of any particular feature and
                reserves the right to modify, replace, or discontinue features in accordance with these
                Terms.
            </p>

            <p id="section11"><b>11. Intellectual Property</b></p>
            <p>
                The Services, including all Platform Content, software, technology, designs, text,
                graphics, logos, trademarks, service marks, trade names, databases, compilations,
                audiovisual works, user interface elements, and all related intellectual property
                rights are owned by or licensed to ShareMy and are protected by United States and
                international intellectual property laws.
            </p>
            <p>
                Except for the limited rights expressly granted in these Terms, ShareMy reserves all
                rights in and to the Services and Platform Content.
            </p>

            <p><b>A. Limited License</b></p>
            <p>
                Subject to your compliance with these Terms, ShareMy grants you a limited, personal,
                non-exclusive, non-transferable, non-sublicensable, revocable license to access and use
                the Services solely for their intended purpose.
            </p>
            <p>This license does not transfer any ownership interest in the Services or Platform Content.</p>

            <p><b>B. Restrictions</b></p>
            <p>Except as expressly permitted by these Terms or applicable law, you may not:</p>
            <ul>
                <li>Copy or reproduce the Services or Platform Content.</li>
                <li>Modify or create derivative works.</li>
                <li>Sell, rent, lease, sublicense, or distribute any portion of the Services.</li>
                <li>Reverse engineer, decompile, or attempt to discover source code.</li>
                <li>Remove copyright, trademark, or proprietary notices.</li>
                <li>Use automated systems to scrape or harvest data.</li>
                <li>Use the Services to build or train a competing product except as permitted by applicable law.</li>
                <li>Use ShareMy's trademarks without prior written permission.</li>
            </ul>

            <p><b>C. Trademarks</b></p>
            <p>
                "ShareMy," the ShareMy logo, and related names, logos, slogans, graphics, and service
                marks are trademarks or service marks of ShareMy Inc.
            </p>
            <p>Nothing in these Terms grants permission to use ShareMy's trademarks without prior written authorization.</p>

            <p><b>D. Copyright Policy</b></p>
            <p>ShareMy respects the intellectual property rights of others.</p>
            <p>
                If you believe material available through the Services infringes your copyright or other
                intellectual property rights, you may submit a written notice containing sufficient
                information for ShareMy to investigate.
            </p>
            <p>
                ShareMy may remove allegedly infringing material and may suspend or terminate repeat
                infringers where appropriate.
            </p>

            <p id="section12"><b>12. Third-Party Services and Links</b></p>
            <p>
                The Services may integrate with or provide access to third-party products, services,
                websites, applications, payment processors, mapping services, communication providers,
                authentication providers, analytics providers, or other technologies.
            </p>
            <p>These third-party services are provided for convenience and functionality only.</p>

            <p><b>A. No Control</b></p>
            <p>ShareMy does not own or control third-party services and is not responsible for:</p>
            <ul>
                <li>Their content.</li>
                <li>Their privacy practices.</li>
                <li>Their availability.</li>
                <li>Their security.</li>
                <li>Their performance.</li>
                <li>Their policies.</li>
                <li>Their products or services.</li>
            </ul>
            <p>Your use of third-party services is governed by the applicable third party's own terms and privacy policies.</p>

            <p><b>B. Third-Party Providers</b></p>
            <p>ShareMy may use third-party providers for services such as:</p>
            <ul>
                <li>Authentication.</li>
                <li>Payment processing.</li>
                <li>Mapping.</li>
                <li>Messaging.</li>
                <li>Analytics.</li>
                <li>Cloud hosting.</li>
                <li>Customer support.</li>
                <li>Fraud prevention.</li>
                <li>Other operational services.</li>
            </ul>
            <p>ShareMy may change providers at any time.</p>

            <p><b>C. External Links</b></p>
            <p>The Services may contain links to third-party websites.</p>
            <p>ShareMy does not endorse or guarantee any third-party website or its content.</p>
            <p>Accessing third-party websites is entirely at your own risk.</p>

            <p id="section13"><b>13. Disclaimers</b></p>
            <p>
                TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES ARE PROVIDED "AS IS,"
                "AS AVAILABLE," AND "WITH ALL FAULTS."
            </p>
            <p>
                ShareMy disclaims all express, implied, statutory, and other warranties, including any
                implied warranties of:
            </p>
            <ul>
                <li>Merchantability.</li>
                <li>Fitness for a particular purpose.</li>
                <li>Title.</li>
                <li>Non-infringement.</li>
                <li>Accuracy.</li>
                <li>Availability.</li>
                <li>Reliability.</li>
                <li>Security.</li>
                <li>Compatibility.</li>
                <li>Quiet enjoyment.</li>
            </ul>

            <p><b>A. No Warranty of Availability</b></p>
            <p>ShareMy does not warrant that:</p>
            <ul>
                <li>The Services will be uninterrupted.</li>
                <li>The Services will be error-free.</li>
                <li>Defects will be corrected.</li>
                <li>The Services will always be available.</li>
                <li>The Services will be secure.</li>
                <li>The Services will be free from viruses or harmful components.</li>
            </ul>

            <p><b>B. No Warranty Regarding Users</b></p>
            <p>ShareMy makes no representation or warranty regarding:</p>
            <ul>
                <li>The identity of users.</li>
                <li>The conduct of users.</li>
                <li>User qualifications.</li>
                <li>User experience.</li>
                <li>User certifications.</li>
                <li>User background.</li>
                <li>User intentions.</li>
                <li>User communications.</li>
                <li>User Content.</li>
            </ul>

            <p><b>C. No Warranty Regarding Activities</b></p>
            <p>ShareMy makes no representation or warranty regarding:</p>
            <ul>
                <li>Activities.</li>
                <li>Organizers.</li>
                <li>Participants.</li>
                <li>Locations.</li>
                <li>Equipment.</li>
                <li>Facilities.</li>
                <li>Travel.</li>
                <li>Safety.</li>
                <li>Legality.</li>
                <li>Quality.</li>
                <li>Success.</li>
                <li>Outcomes.</li>
            </ul>

            <p><b>D. No Professional Advice</b></p>
            <p>Information provided through the Services is for general informational purposes only.</p>
            <p>
                Nothing provided by ShareMy constitutes legal, medical, financial, tax, fitness, safety,
                or other professional advice.
            </p>
            <p>Users should obtain appropriate professional advice when necessary.</p>

            <p><b>E. No Reliance</b></p>
            <p>
                You acknowledge that you have not relied upon any representation, statement,
                recommendation, promise, advertisement, communication, or omission by ShareMy except as
                expressly stated in these Terms.
            </p>

            <p id="section14"><b>14. Assumption of Risk</b></p>
            <p>
                You acknowledge that participation in activities, interactions with other users, and use
                of the Services involve risks that cannot be eliminated.
            </p>
            <p>
                These risks may arise from known or unknown conditions and may result from the acts or
                omissions of you, other users, organizers, participants, spectators, independent
                contractors, property owners, businesses, governmental entities, or other third parties.
            </p>
            <p>Such risks may include, without limitation:</p>
            <ul>
                <li>Personal injury.</li>
                <li>Serious bodily injury.</li>
                <li>Illness or disease.</li>
                <li>Emotional distress.</li>
                <li>Disability.</li>
                <li>Death.</li>
                <li>Property damage.</li>
                <li>Property loss.</li>
                <li>Theft.</li>
                <li>Financial loss.</li>
                <li>Travel-related risks.</li>
                <li>Weather conditions.</li>
                <li>Wildlife.</li>
                <li>Natural hazards.</li>
                <li>Equipment failure.</li>
                <li>Road or trail conditions.</li>
                <li>Water conditions.</li>
                <li>Criminal acts.</li>
                <li>Negligence of other participants.</li>
                <li>Misrepresentations made by other users.</li>
                <li>Risks that are unforeseeable or unknown.</li>
            </ul>
            <p>
                You understand that many activities available through the Services may involve physical
                exertion, outdoor environments, remote locations, water, mountains, highways, traffic,
                weather, animals, tools, equipment, or other potentially hazardous conditions.
            </p>
            <p>
                You voluntarily choose to participate in activities arranged through the Services after
                independently evaluating the risks involved.
            </p>
            <p>
                To the fullest extent permitted by applicable law, you knowingly and voluntarily assume
                all risks arising from your use of the Services and from any activity or interaction
                with other users, whether known or unknown, foreseeable or unforeseeable.
            </p>
            <p>Nothing in these Terms waives any rights that cannot lawfully be waived under applicable law.</p>

            <p id="section15"><b>15. Release of Claims</b></p>
            <p>
                To the fullest extent permitted by applicable law, you release and forever discharge
                ShareMy Inc., its current and former officers, directors, shareholders, employees,
                independent contractors acting within the scope of their engagement, affiliates,
                successors, assigns, licensors, service providers, and agents (collectively, the
                "Released Parties") from any and all claims, demands, causes of action, damages, losses,
                liabilities, costs, and expenses of every kind, whether known or unknown, suspected or
                unsuspected, arising out of or relating to:
            </p>
            <ul>
                <li>Your use of the Services.</li>
                <li>Your participation in activities.</li>
                <li>Your interactions with other users.</li>
                <li>Invitations or recommendations.</li>
                <li>User Content.</li>
                <li>User communications.</li>
                <li>Third-party services.</li>
                <li>Acts or omissions of users or third parties.</li>
                <li>Cancellation or modification of activities.</li>
                <li>Injuries, property damage, financial loss, emotional distress, or other losses occurring before, during, or after activities.</li>
            </ul>
            <p>
                This release applies regardless of the legal theory asserted, including contract, tort
                (including negligence), statute, or otherwise, except to the extent prohibited by
                applicable law or resulting from ShareMy's gross negligence, willful misconduct, or
                other liability that cannot legally be limited or released.
            </p>
            <p>
                If the law of your jurisdiction limits releases of unknown claims, this release applies
                to the fullest extent permitted by that law.
            </p>

            <p id="section16"><b>16. Limitation of Liability</b></p>
            <p>
                TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE RELEASED PARTIES SHALL NOT BE
                LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE, OR
                ENHANCED DAMAGES, OR FOR ANY LOSS OF PROFITS, REVENUE, BUSINESS OPPORTUNITY, GOODWILL,
                DATA, USE, OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR RELATING TO THE SERVICES OR
                THESE TERMS, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p>Without limiting the foregoing, the Released Parties shall not be liable for damages arising from:</p>
            <ul>
                <li>Activities organized by users.</li>
                <li>Conduct of users.</li>
                <li>Communications between users.</li>
                <li>Recommendations or matching features.</li>
                <li>User Content.</li>
                <li>Identity misrepresentation.</li>
                <li>Criminal acts.</li>
                <li>Personal injury.</li>
                <li>Property damage.</li>
                <li>Financial losses.</li>
                <li>Travel expenses.</li>
                <li>Equipment failures.</li>
                <li>Third-party services.</li>
                <li>Network outages.</li>
                <li>Unauthorized account access.</li>
                <li>Errors, interruptions, delays, or data loss.</li>
            </ul>
            <p>
                To the fullest extent permitted by applicable law, the aggregate liability of the
                Released Parties for all claims arising out of or relating to the Services shall not
                exceed the greater of:
            </p>
            <ul>
                <li>One hundred U.S. dollars (US $100); or</li>
                <li>The total amount you paid directly to ShareMy for paid Services during the twelve (12) months immediately preceding the event giving rise to the claim.</li>
            </ul>
            <p>
                Some jurisdictions do not allow certain limitations of liability. In those jurisdictions,
                this section applies only to the maximum extent permitted by applicable law.
            </p>

            <p id="section17"><b>17. Indemnification</b></p>
            <p>
                To the fullest extent permitted by applicable law, you agree to defend, indemnify, and
                hold harmless the Released Parties from and against any and all claims, demands, actions,
                proceedings, investigations, liabilities, damages, judgments, settlements, fines,
                penalties, losses, costs, and expenses (including reasonable attorneys' fees and legal
                expenses) arising out of or relating to:
            </p>
            <ul>
                <li>Your use of the Services.</li>
                <li>Your User Content.</li>
                <li>Activities you organize, host, lead, promote, or participate in.</li>
                <li>Your communications with other users.</li>
                <li>Your violation of these Terms or any related ShareMy policy.</li>
                <li>Your violation of applicable law.</li>
                <li>Your infringement or misappropriation of the intellectual property, privacy, publicity, or other rights of any person or entity.</li>
                <li>Any dispute between you and another user or third party.</li>
            </ul>
            <p>
                ShareMy reserves the right, at its own expense, to assume the exclusive defense and
                control of any matter otherwise subject to indemnification by you. If ShareMy does so,
                you agree to cooperate fully in the defense of that matter.
            </p>
            <p>Your indemnification obligations survive termination of your account and these Terms.</p>

            <p id="section18"><b>18. Suspension and Termination</b></p>
            <p>
                ShareMy may, in its sole discretion and to the fullest extent permitted by applicable
                law, suspend, restrict, disable, or terminate your account or access to the Services at
                any time, with or without notice, for any lawful reason, including if ShareMy reasonably
                believes that:
            </p>
            <ul>
                <li>You have violated these Terms or any related ShareMy policy.</li>
                <li>You have violated applicable law.</li>
                <li>Your conduct creates a risk to other users or to ShareMy.</li>
                <li>Your account contains false or misleading information.</li>
                <li>Your use of the Services is fraudulent, abusive, deceptive, or harmful.</li>
                <li>Continued access may expose ShareMy or others to legal, financial, operational, or security risks.</li>
            </ul>
            <p>
                Nothing in these Terms obligates ShareMy to continue providing the Services or to
                maintain any particular account.
            </p>

            <p><b>A. Effect of Termination</b></p>
            <p>Upon termination:</p>
            <ul>
                <li>Your right to use the Services immediately ends.</li>
                <li>Licenses granted to you under these Terms automatically terminate.</li>
                <li>ShareMy may disable or delete your account.</li>
                <li>ShareMy may remove or retain User Content as described in the Privacy Policy and these Terms.</li>
                <li>You remain responsible for obligations that arose before termination.</li>
            </ul>
            <p>Termination does not affect provisions that by their nature are intended to survive termination.</p>

            <p><b>B. Survival</b></p>
            <p>The following provisions survive termination of these Terms or your account:</p>
            <ul>
                <li>User Content licenses.</li>
                <li>Intellectual Property.</li>
                <li>Disclaimers.</li>
                <li>Assumption of Risk.</li>
                <li>Release of Claims.</li>
                <li>Limitation of Liability.</li>
                <li>Indemnification.</li>
                <li>Dispute Resolution.</li>
                <li>Governing Law.</li>
                <li>Any other provision that by its nature should survive termination.</li>
            </ul>

            <p id="section19"><b>19. Dispute Resolution and Arbitration</b></p>
            <p>Please read this section carefully. It affects your legal rights.</p>
            <p>To the fullest extent permitted by applicable law, you and ShareMy agree to resolve disputes as follows.</p>

            <p><b>A. Informal Resolution</b></p>
            <p>
                Before initiating arbitration or filing a lawsuit, the party asserting a claim agrees to
                provide written notice describing the dispute in reasonable detail.
            </p>
            <p>
                The parties agree to make a good-faith effort to resolve the dispute informally for at
                least thirty (30) days before commencing formal proceedings, unless emergency
                injunctive relief is necessary.
            </p>

            <p><b>B. Binding Arbitration</b></p>
            <p>
                Except for claims that may be brought in small claims court or claims seeking temporary
                injunctive relief, any dispute arising out of or relating to these Terms or the Services
                shall be resolved by binding arbitration rather than in court, to the fullest extent
                permitted by applicable law.
            </p>
            <p>
                The arbitration shall be administered by the arbitration provider designated by ShareMy
                in effect at the time the dispute arises, under that provider's applicable consumer
                arbitration rules.
            </p>
            <p>
                Unless otherwise required by applicable law or agreed by the parties, the arbitration
                shall take place in Idaho.
            </p>
            <p>
                The arbitrator shall have exclusive authority to resolve disputes regarding the
                interpretation, applicability, enforceability, or formation of this arbitration
                agreement, except where applicable law provides otherwise.
            </p>

            <p><b>C. Class Action Waiver</b></p>
            <p>
                To the fullest extent permitted by applicable law, all disputes shall be conducted
                solely on an individual basis.
            </p>
            <p>
                Neither you nor ShareMy may participate as a plaintiff, claimant, class representative,
                or class member in any class action, collective action, consolidated action, or
                representative proceeding.
            </p>
            <p>
                The arbitrator may not consolidate claims or preside over any class or representative
                proceeding except where required by applicable law.
            </p>

            <p><b>D. Small Claims Court</b></p>
            <p>
                Either party may bring an individual claim in a court of competent jurisdiction that
                qualifies for small claims court, provided the claim remains on an individual basis.
            </p>

            <p><b>E. Time Limitation</b></p>
            <p>
                To the fullest extent permitted by applicable law, any claim relating to the Services or
                these Terms must be commenced within one (1) year after the claim arises, unless a
                longer period is required by law.
            </p>

            <p id="section20"><b>20. Governing Law</b></p>
            <p>
                These Terms and any dispute arising out of or relating to the Services shall be governed
                by the laws of the State of Idaho, without regard to its conflict-of-law principles.
            </p>
            <p>
                Subject to the arbitration provisions above, any legal action that is not required to be
                arbitrated shall be brought exclusively in the state or federal courts located in Idaho,
                and each party consents to the personal jurisdiction of those courts, except where
                applicable law provides otherwise.
            </p>

            <p id="section21"><b>21. Changes to These Terms</b></p>
            <p>ShareMy may modify these Terms from time to time.</p>
            <p>
                When material changes are made, ShareMy may provide notice by posting the updated Terms
                through the Services, by email, or through another reasonable method.
            </p>
            <p>
                The updated Terms become effective on the effective date identified in the revised Terms
                unless applicable law requires otherwise.
            </p>
            <p>
                Your continued use of the Services after the effective date constitutes your acceptance
                of the revised Terms to the extent permitted by applicable law.
            </p>
            <p>If you do not agree to the revised Terms, you must stop using the Services and close your account.</p>

            <p id="section22"><b>22. Miscellaneous</b></p>

            <p><b>A. Entire Agreement</b></p>
            <p>
                These Terms, together with the Privacy Policy, Community Guidelines, Safety Guidelines,
                Cookie Policy, and any other documents expressly incorporated by reference, constitute
                the entire agreement between you and ShareMy regarding the Services.
            </p>

            <p><b>B. Severability</b></p>
            <p>
                If any provision of these Terms is determined to be invalid, illegal, or unenforceable,
                the remaining provisions remain in full force and effect to the fullest extent permitted
                by law.
            </p>
            <p>
                Any invalid provision shall be enforced to the maximum extent permitted by applicable
                law while preserving the original intent of the provision whenever possible.
            </p>

            <p><b>C. No Waiver</b></p>
            <p>
                Failure by ShareMy to enforce any provision of these Terms shall not constitute a waiver
                of that provision or any other provision.
            </p>
            <p>Any waiver must be in writing and signed by an authorized representative of ShareMy.</p>

            <p><b>D. Assignment</b></p>
            <p>
                You may not assign or transfer these Terms or any rights or obligations under them
                without ShareMy's prior written consent.
            </p>
            <p>
                ShareMy may assign these Terms, in whole or in part, without restriction in connection
                with a merger, acquisition, sale of assets, corporate reorganization, financing, or by
                operation of law.
            </p>

            <p><b>E. Force Majeure</b></p>
            <p>
                ShareMy shall not be liable for any delay or failure to perform resulting from events
                beyond its reasonable control, including natural disasters, acts of God, war, terrorism,
                labor disputes, internet outages, cyberattacks, governmental actions, epidemics,
                pandemics, utility failures, or failures of third-party providers.
            </p>

            <p><b>F. Electronic Communications and Signatures</b></p>
            <p>
                You agree that these Terms, notices, disclosures, agreements, and other communications
                provided electronically satisfy any legal requirement that such communications be in
                writing.
            </p>
            <p>
                You agree that your electronic acceptance of these Terms has the same legal effect as a
                handwritten signature.
            </p>

            <p><b>G. Interpretation</b></p>
            <p>Headings are provided for convenience only and do not affect the interpretation of these Terms.</p>
            <p>Words such as "including" or "includes" mean "including without limitation."</p>
            <p>References to the singular include the plural where appropriate, and vice versa.</p>

            <p id="section23"><b>23. Contact Information</b></p>
            <p>
                If you have questions about these Terms, the Services, or your ShareMy account, you may
                contact ShareMy using the information below.
            </p>
            <p>ShareMy Inc.</p>
            <p>
                Email: <a href="mailto:support@sharemy.com">support@sharemy.com</a>
            </p>
            <p>
                Website: <a href="https://www.sharemy.com">https://www.sharemy.com</a>
            </p>
            <p>
                ShareMy Inc.
                <br />
                6444 E Old Oregon Trail Rd
                <br />
                Lava Hot Springs, Idaho, United States
            </p>
            <p>
                If you are contacting ShareMy regarding a legal notice, copyright claim, or other legal
                matter, please include sufficient information to identify yourself and the nature of
                your request so that we can respond appropriately.
            </p>
        </div>
    );
};

export default TermsOfUse;
